import { useState, useEffect } from 'react';

const BREAKPOINT = {
  MOBILE: 768,
  TABLET: 992,
  SMALL_DESKTOP: 1200,
};

export enum ScreenSize {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    isMobile: window.innerWidth < BREAKPOINT.MOBILE,
    isTablet: window.innerWidth >= BREAKPOINT.MOBILE && window.innerWidth < BREAKPOINT.TABLET,
    isDesktop: window.innerWidth >= BREAKPOINT.TABLET,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        isMobile: window.innerWidth < BREAKPOINT.MOBILE,
        isTablet: window.innerWidth >= BREAKPOINT.MOBILE && window.innerWidth < BREAKPOINT.TABLET,
        isDesktop: window.innerWidth >= BREAKPOINT.TABLET,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
